import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BooleanCellRenderer = ({ value }) => {
  if (value == null) return <span />

  if (value === 'Y' || value === true || value === 'TRUE') {
    return <FontAwesomeIcon icon={far.faCheck} color="green"/>
  } else {
    return <FontAwesomeIcon icon={far.faTimes} color="red"/>
  }
}